import { render, staticRenderFns } from "./MyRewardsScene.vue?vue&type=template&id=a893f90a&scoped=true&"
import script from "./MyRewardsScene.vue?vue&type=script&lang=js&"
export * from "./MyRewardsScene.vue?vue&type=script&lang=js&"
import style0 from "./MyRewardsScene.vue?vue&type=style&index=0&id=a893f90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a893f90a",
  null
  
)

export default component.exports